<template>
  <div class="hkList" v-if="!showLoad">
    <ul class="list_ul">
      <li class="list_li dis_flex" v-for="(item) in dataList" :key="item.id">
        <div>
          <p class="clearfix cz">
            <span>办理金额：</span>
            {{item.amount}}（元）
            <a
              class="fr"
              href="javascript:void(0);"
              @click="delInput(item)"
              :class="[ item.isRecall == true ? 'noneStyle' : '']"
            >{{changeText(item.isRecall)}}</a>
          </p>
          <p>
            <span>办理人：</span>
            {{item.realName}}
          </p>
          <p>
            <span>办理时间：</span>
            {{item.createTime}}
          </p>
          <p>
            <span>到账时间：</span>
            {{item.accountTime}}
          </p>
          <!-- <p class="cz">
            <a
              href="javascript:void(0);"
              @click="delInput(item)"
              :class="[ item.isRecall == true ? 'noneStyle' : '']"
            >{{changeText(item.isRecall)}}</a>
          </p>-->
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { dateFormat } from "@/utils/common";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "delHkList",
  data() {
    return {
      mode: "",
      commonId: "", //发票id
      commonType: "",
      dataList: "",
      baseData: {},
      clientType: getDeviceType() //手机类型
    };
  },
  mounted() {
    document.title = "回款明细";
    this.setShowLoad(false);
    this.commonId = this.$route.query.commonId; //申请Id
    this.commonType = this.$route.query.commonType; //type
    this.mode = this.$route.query.pageType; //type
    this.initPage();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      let _this = this;
      _this.$api.finance.account
        .viewDetail(_this.mode, {
          relationId: this.commonId,
          accountType: this.commonType
        })
        .then(res => {
          if (res.code == "1" && res.data != null) {
            _this.dataList = res.data;
          } else {
            console.log(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    changeText(type) {
      let text = "";
      if (type) {
        text = "已撤销";
      } else {
        text = "撤销";
      }
      return text;
    },
    delInput(item) {
      //撤销操作
      let _this = this;
      if (!item.isRecall) {
        _this.$dialog
          .confirm({
            title: "提示",
            message: "确认撤回操作吗？"
          })
          .then(() => {
            _this.$api.finance.account
              .delReturn(_this.mode, { id: item.id })
              .then(res => {
                if (res.code == "1" && res.data != null) {
                  _this.$toast("撤回操作成功");
                  if (_this.clientType == "android") {
                    window.android.getInfo(113);
                  } else {
                    window.webkit.messageHandlers.reviewType.postMessage(null);
                  }
                  setTimeout(function() {
                    window.location.reload();
                  }, 2000);
                } else {
                  _this.$toast(res.msg);
                }
              })
              .catch(err => {
                _this.$toast("网络失败，请稍后重试");
              });
          })
          .catch(() => {
            // on cancel
          });
      }
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
<style lang="less">
.hkList {
  width: 100%;
  min-height: 100%;
  background-color: #f6f6f6;
  .list_ul {
    width: 85%;
    margin: 0 auto;
    padding-top: 10px;

    li {
      width: 100%;
      background-color: #fff;
      margin: 10px 0;
      padding: 15px 10px;
      border-radius: 8px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      position: relative;
      > div {
        width: 100%;
      }
      p {
        margin: 8px 0;
        color: #333;
        font-size: 15px;
        span {
          color: #666;
        }
      }
      .cz {
        position: relative;
        width: 100%;
        a {
          position: absolute;
          top: 0;
          right: 10px;
          display: block;
          width: 40px;
          border: 0 none;
          padding: 6px 6px;
          font-size: 10px;
          background-color: #2581d6;
          color: #fff;
          text-align: center;
          border-radius: 5px;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
        }
        a.noneStyle {
          background-color: #eee;
          color: #333;
        }
      }
    }
  }
}
</style>